import api from "../config/api";

export const getJobs = async (data) => {
  const res = await api.post("jobs/getJobs", data);
  return res.data;
};

export const getJobByid = async (_id) => {
  const res = await api.get(`jobs/${_id}`);
  return res.data;
};

export const getJobsGroupedByOrganization = async (data) => {
  const res = await api.post("jobs/getJobs", {
    ...data,
    groupBy: "organization",
  });
  return res.data;
};

export const getJobsWithNoPos = async (data) => {
  const res = await api.post("jobs/getJobsWithNoPos", data);
  return res.data;
};

export const getJobScheduleDetails = async (job_id) => {
  const res = await api.get(`jobs/schedule/${job_id}`);
  return res.data;
};
